/*
  version : matrix node v3.0
*/
export default {
    Manager: [{
        Title: '我的',
        Code: '',
        ShowTitle: '工作台',
        SortNo: '',
        Path: 'Manager',
        DetailView: '',
        ListView: '',
        Page: '首页',
        PageColumns: '',
        ViewType: '面板',
        Theme: '',
        Panel: 'Home',
        PanelModule: '标准商城首页模板1',
        Role: '管理员自己',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Theme: 'top2'
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Self'
        }],
        Id: 0
    }],
    Company: [{
        Title: '企业数',
        Code: '',
        ShowTitle: '',
        SortNo: 2,
        Path: 'Company',
        DetailView: '',
        ListView: '',
        Page: '工作台第一排',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'DataPanel',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '企业',
        Code: '',
        ShowTitle: '企业',
        SortNo: '',
        Path: 'Company',
        DetailView: '',
        ListView: '',
        Page: '企业',
        PageColumns: '',
        ViewType: '面板',
        Theme: '',
        Panel: 'Home4',
        PanelModule: '管理首页4',
        Role: '管理员自己',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Theme: 'top2'
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Parent'
        }],
        Id: 1
    },
    {
        Title: '企业管理',
        Code: '',
        ShowTitle: '',
        SortNo: 1,
        Path: 'Company',
        DetailView: '',
        ListView: '',
        Page: '企业菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 2
    },
    {
        Title: '企业管理',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Company',
        DetailView: '企业详情',
        ListView: '',
        Page: '企业企业管理',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            NoConditionColumns: ['员工', '企业']
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 3
    },
    {
        Title: '企业详情',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Company',
        DetailView: '',
        ListView: '',
        Page: '企业详情',
        PageColumns: '',
        ViewType: '视图面板',
        Theme: '',
        Panel: 'Detail',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 4
    }],
    Staff: [{
        Title: '企业员工总数',
        Code: '',
        ShowTitle: '',
        SortNo: 5,
        Path: 'Staff',
        DetailView: '',
        ListView: '',
        Page: '工作台第一排',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'DataPanel',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '管理人员数量',
        Code: '',
        ShowTitle: '',
        SortNo: 3,
        Path: 'Staff',
        DetailView: '',
        ListView: '',
        Page: '企业详情',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'IndexPanel',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Company',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    },
    {
        Title: '管理员工',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Staff',
        DetailView: '',
        ListView: '',
        Page: '企业详情',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Company',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            NoConditionColumns: ['员工', '企业']
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 2
    },
    {
        Title: '企业管理员工数',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Staff',
        DetailView: '',
        ListView: '',
        Page: '企业管理员工数',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'ListData',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Company',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 3
    }],
    Users: [{
        Title: '用户总数',
        Code: '',
        ShowTitle: '',
        SortNo: 1,
        Path: 'Users',
        DetailView: '',
        ListView: '',
        Page: '工作台第一排',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'DataPanel',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '人员类型占比',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Users',
        DetailView: '',
        ListView: '',
        Page: '工作台第二排中间',
        PageColumns: '',
        ViewType: '面板',
        Theme: '',
        Panel: 'RosePie',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    },
    {
        Title: '人员数量',
        Code: '',
        ShowTitle: '',
        SortNo: 1,
        Path: 'Users',
        DetailView: '',
        ListView: '',
        Page: '企业详情',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'IndexPanel',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Company',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 2
    },
    {
        Title: '企业人员',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Users',
        DetailView: '',
        ListView: '',
        Page: '企业详情',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Company',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            LoadParams: {
                UsersSearchParams: {
                    GetCategory: true
                },
                GetCompany: true
            },
            NoConditionColumns: ['员工', '企业']
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 3
    },
    {
        Title: '企业管理人员数',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Users',
        DetailView: '',
        ListView: '',
        Page: '企业管理人员数',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'ListData',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Company',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 4
    },
    {
        Title: '学员',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Users',
        DetailView: '',
        ListView: '',
        Page: '学员',
        PageColumns: '',
        ViewType: '面板',
        Theme: '',
        Panel: 'Home4',
        PanelModule: '管理首页4',
        Role: '管理员自己',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Theme: 'top2'
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Parent'
        }],
        Id: 5
    },
    {
        Title: '学员管理',
        Code: '',
        ShowTitle: '',
        SortNo: 1,
        Path: 'Users',
        DetailView: '',
        ListView: '',
        Page: '学员菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 6
    },
    {
        Title: '学员管理',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Users',
        DetailView: '学员详情',
        ListView: '',
        Page: '学员学员管理',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            NoConditionColumns: ['员工', '企业'],
            LoadParams: {
                GetCompany: true
            }
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 7
    },
    {
        Title: '学员详情',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Users',
        DetailView: '',
        ListView: '',
        Page: '学员详情',
        PageColumns: '',
        ViewType: '视图面板',
        Theme: '',
        Panel: 'Detail',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 8
    },
    {
        Title: '邀请学员',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Users',
        DetailView: '',
        ListView: '',
        Page: '选择邀请学员',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'Line2',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            TreeField: 'Company',
            TreeFieldHeight: 'calc(100vh - 120px)',
            Selected: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 9
    }],
    Users_Category: [{
        Title: '人员类型',
        Code: '',
        ShowTitle: '',
        SortNo: 2,
        Path: 'Users.Category',
        DetailView: '',
        ListView: '',
        Page: '学员菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '人员类型',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Users.Category',
        DetailView: '',
        ListView: '',
        Page: '学员人员类型',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            NoConditionColumns: ['员工', '企业']
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    }],
    Users_Plan: [{
        Title: '完成培训学员',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Users.Plan',
        DetailView: '',
        ListView: '',
        Page: '工作台第二排中间1',
        PageColumns: '',
        ViewType: '面板',
        Theme: '',
        Panel: 'Water',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '参加培训数',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Users.Plan',
        DetailView: '',
        ListView: '',
        Page: '学员详情',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'DataPanel',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    },
    {
        Title: '培训记录',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Users.Plan',
        DetailView: '',
        ListView: '',
        Page: '学员详情',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Parent',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            LoarParams: {
                GetTraining: true
            }
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 2
    },
    {
        Title: '培训学员',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Users.Plan',
        DetailView: '',
        ListView: '',
        Page: '培训详情',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Training',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 3
    }],
    Users_Sign: [{
        Title: '签到记录',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Users.Sign',
        DetailView: '',
        ListView: '',
        Page: '学员详情',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Parent',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            NoConditionColumns: ['员工', '企业']
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    }],
    Users_LearnRecord: [{
        Title: '观看视频次数',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Users.LearnRecord',
        DetailView: '',
        ListView: '',
        Page: '学员详情',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'DataPanel',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '学习记录',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Users.LearnRecord',
        DetailView: '',
        ListView: '',
        Page: '学员详情',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Parent',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    }],
    Users_CheckCar: [{
        Title: '车辆巡检记录',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Users.CheckCar',
        DetailView: '',
        ListView: '',
        Page: '工作台第二排左侧',
        PageColumns: '',
        ViewType: '面板',
        Theme: '',
        Panel: 'Rank',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '车辆巡检',
        Code: '',
        ShowTitle: '',
        SortNo: 4,
        Path: 'Users.CheckCar',
        DetailView: '',
        ListView: '',
        Page: '安全菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    },
    {
        Title: '车辆巡检',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Users.CheckCar',
        DetailView: '',
        ListView: '',
        Page: '安全车辆巡检',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            }
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 2
    }],
    Site: [{
        Title: '顶部导航',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Site',
        DetailView: '',
        ListView: '',
        Page: '工作台顶部',
        PageColumns: '',
        ViewType: '面板',
        Theme: '',
        Panel: 'Nav',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '设置',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Site',
        DetailView: '',
        ListView: '',
        Page: '设置',
        PageColumns: '',
        ViewType: '面板',
        Theme: '',
        Panel: 'Home4',
        PanelModule: '管理首页4',
        Role: '管理员自己',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Theme: 'top2'
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Parent'
        }],
        Id: 1
    }],
    Site_Banners: [{
        Title: '小程序轮播图',
        Code: '',
        ShowTitle: '',
        SortNo: 1,
        Path: 'Site.Banners',
        DetailView: '',
        ListView: '',
        Page: '设置菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '小程序轮播图',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Site.Banners',
        DetailView: '',
        ListView: '',
        Page: '设置小程序轮播图',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            NoConditionColumns: ['员工', '企业']
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    }],
    Site_Area: [{
        Title: '省市管理',
        Code: '',
        ShowTitle: '',
        SortNo: 2,
        Path: 'Site.Area',
        DetailView: '',
        ListView: '',
        Page: '设置菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '省市管理',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Site.Area',
        DetailView: '',
        ListView: '',
        Page: '设置省市管理',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            NoConditionColumns: ['上级区域', '员工', '企业']
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    }],
    Training: [{
        Title: '培训总数',
        Code: '',
        ShowTitle: '',
        SortNo: 4,
        Path: 'Training',
        DetailView: '',
        ListView: '',
        Page: '工作台第一排',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'DataPanel',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '培训',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Training',
        DetailView: '',
        ListView: '',
        Page: '培训',
        PageColumns: '',
        ViewType: '面板',
        Theme: '',
        Panel: 'Home4',
        PanelModule: '管理首页4',
        Role: '管理员自己',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Theme: 'top2'
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Parent'
        }],
        Id: 1
    },
    {
        Title: '培训',
        Code: '',
        ShowTitle: '',
        SortNo: 1,
        Path: 'Training',
        DetailView: '',
        ListView: '',
        Page: '培训菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 2
    },
    {
        Title: '培训',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Training',
        DetailView: '培训详情',
        ListView: '',
        Page: '培训培训',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            NoConditionColumns: ['员工', '企业'],
            LoadParams: {
                GetCompany: true,
                GetLessonsList: true
            }
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 3
    },
    {
        Title: '培训详情',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Training',
        DetailView: '',
        ListView: '',
        Page: '培训详情',
        PageColumns: '',
        ViewType: '视图面板',
        Theme: '',
        Panel: 'Detail',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 4
    },
    {
        Title: '已邀学员',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Training',
        DetailView: '',
        ListView: '',
        Page: '选择培训人员',
        PageColumns: '',
        ViewType: '视图面板',
        Theme: '',
        Panel: 'Detail',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Parent',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 5
    }],
    Training_Category: [{
        Title: '培训分类',
        Code: '',
        ShowTitle: '',
        SortNo: 2,
        Path: 'Training.Category',
        DetailView: '',
        ListView: '',
        Page: '培训菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '培训分类',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Training.Category',
        DetailView: '',
        ListView: '',
        Page: '培训培训分类',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            NoConditionColumns: ['员工', '企业']
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    }],
    Training_Lessons: [{
        Title: '培训课件',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Training.Lessons',
        DetailView: '培训课件详情',
        ListView: '',
        Page: '培训详情',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Parent',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '培训课件详情',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Training.Lessons',
        DetailView: '',
        ListView: '',
        Page: '培训课件详情',
        PageColumns: '',
        ViewType: '视图面板',
        Theme: '',
        Panel: 'Detail',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Parent',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    },
    {
        Title: '培训课件',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Training.Lessons',
        DetailView: '',
        ListView: '',
        Page: '培训课件',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Parent',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            HideTitle: true,
            DisabledCondition: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 2
    }],
    Training_Lessons_Record: [{
        Title: '学习记录',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Training.Lessons.Record',
        DetailView: '',
        ListView: '',
        Page: '培训课件详情',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Parent',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    }],
    Training_Users: [{
        Title: '已邀学员列表',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Training.Users',
        DetailView: '',
        ListView: '',
        Page: '已邀学员',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'Line',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: 0,
        ParentField: 'Parent',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            HideTitle: true,
            Adds: {
                Title: '邀请学员',
                SelectField: 'TrainUsers'
            }
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '参培人员明细',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Training.Users',
        DetailView: '',
        ListView: '',
        Page: '参培人员明细',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Parent',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            HideTitle: true,
            DisabledCondition: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    }],
    Training_ImportUser: [{
        Title: '批量导入学员',
        Code: '',
        ShowTitle: '',
        SortNo: 3,
        Path: 'Training.ImportUser',
        DetailView: '',
        ListView: '',
        Page: '培训菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '批量导入学员',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Training.ImportUser',
        DetailView: '',
        ListView: '',
        Page: '培训批量导入学员',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            LoadParams: {
                GetTraining: true
            }
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    }],
    Training_UserCheckList: [{
        Title: '企业学员检测记录',
        Code: '',
        ShowTitle: '',
        SortNo: 4,
        Path: 'Training.UserCheckList',
        DetailView: '',
        ListView: '',
        Page: '培训菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '企业学员检测记录',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Training.UserCheckList',
        DetailView: '',
        ListView: '',
        Page: '培训企业学员检测记录',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            LoadParams: {
                GetTraining: true
            }
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    }],
    Library: [{
        Title: '题库',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Library',
        DetailView: '',
        ListView: '',
        Page: '题库',
        PageColumns: '',
        ViewType: '面板',
        Theme: '',
        Panel: 'Home4',
        PanelModule: '管理首页4',
        Role: '管理员自己',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Theme: 'top2'
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Parent'
        }],
        Id: 0
    },
    {
        Title: '题库管理',
        Code: '',
        ShowTitle: '',
        SortNo: 1,
        Path: 'Library',
        DetailView: '',
        ListView: '',
        Page: '题库菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    },
    {
        Title: '题库管理',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Library',
        DetailView: '题库详情',
        ListView: '',
        Page: '题库题库管理',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            NoConditionColumns: ['员工'],
            LoadParams: {
                GetCompany: true
            }
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 2
    },
    {
        Title: '题库详情',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Library',
        DetailView: '',
        ListView: '',
        Page: '题库详情',
        PageColumns: '',
        ViewType: '视图面板',
        Theme: '',
        Panel: 'Detail',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 3
    }],
    Library_Category: [{
        Title: '题库分类',
        Code: '',
        ShowTitle: '',
        SortNo: 2,
        Path: 'Library.Category',
        DetailView: '',
        ListView: '',
        Page: '题库菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '题库分类',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Library.Category',
        DetailView: '',
        ListView: '',
        Page: '题库题库分类',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            NoConditionColumns: ['员工', '企业']
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    }],
    Library_Question: [{
        Title: '所有题目',
        Code: '',
        ShowTitle: '',
        SortNo: 3,
        Path: 'Library.Question',
        DetailView: '',
        ListView: '',
        Page: '题库菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '所有题目',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Library.Question',
        DetailView: '',
        ListView: '',
        Page: '题库所有题目',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            NoConditionColumns: ['员工', '企业']
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    },
    {
        Title: '题目列表',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Library.Question',
        DetailView: '',
        ListView: '',
        Page: '题库详情题目列表',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Parent',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            NoConditionColumns: ['员工', '企业', '题库']
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 2
    },
    {
        Title: '题目总数',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Library.Question',
        DetailView: '',
        ListView: '',
        Page: '题库详情顶部统计',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'IndexPanel',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Parent',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: {
            ModuleType: [1, 2, 3, 4]
        },
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 3
    },
    {
        Title: '单选题目',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Library.Question',
        DetailView: '',
        ListView: '',
        Page: '题库详情顶部统计',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'IndexPanel',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Parent',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            LoadParams: {
                ModuleType: 1
            }
        },
        ColumnConfig: {
            ModuleType: 1
        },
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 4
    },
    {
        Title: '多选题目',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Library.Question',
        DetailView: '',
        ListView: '',
        Page: '题库详情顶部统计',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'IndexPanel',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Parent',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            LoadParams: {
                ModuleType: 2
            }
        },
        ColumnConfig: {
            ModuleType: 2
        },
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 5
    },
    {
        Title: '判断题目',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Library.Question',
        DetailView: '',
        ListView: '',
        Page: '题库详情顶部统计',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'IndexPanel',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Parent',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            LoadParams: {
                ModuleType: 3
            }
        },
        ColumnConfig: {
            ModuleType: 3
        },
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 6
    },
    {
        Title: '填空题目',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Library.Question',
        DetailView: '',
        ListView: '',
        Page: '题库详情顶部统计',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'IndexPanel',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Parent',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            LoadParams: {
                ModuleType: 4
            }
        },
        ColumnConfig: {
            ModuleType: 4
        },
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 7
    }],
    Paper: [{
        Title: '试卷',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Paper',
        DetailView: '',
        ListView: '',
        Page: '试卷',
        PageColumns: '',
        ViewType: '面板',
        Theme: '',
        Panel: 'Home4',
        PanelModule: '管理首页4',
        Role: '管理员自己',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Theme: 'top2'
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Parent'
        }],
        Id: 0
    },
    {
        Title: '试卷管理',
        Code: '',
        ShowTitle: '',
        SortNo: 1,
        Path: 'Paper',
        DetailView: '',
        ListView: '',
        Page: '试卷菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    },
    {
        Title: '试卷管理',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Paper',
        DetailView: '试卷详情',
        ListView: '',
        Page: '试卷试卷管理',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            NoConditionColumns: ['员工'],
            LoadParams: {
                GetCompany: true
            }
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 2
    },
    {
        Title: '试卷详情',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Paper',
        DetailView: '',
        ListView: '',
        Page: '试卷详情',
        PageColumns: '',
        ViewType: '视图面板',
        Theme: '',
        Panel: 'Detail',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Parent',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 3
    }],
    Paper_Category: [{
        Title: '试卷分类',
        Code: '',
        ShowTitle: '',
        SortNo: 2,
        Path: 'Paper.Category',
        DetailView: '',
        ListView: '',
        Page: '试卷菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '试卷分类',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Paper.Category',
        DetailView: '',
        ListView: '',
        Page: '试卷试卷分类',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            NoConditionColumns: ['员工', '企业']
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    }],
    Paper_Topic: [{
        Title: '题目列表',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Paper.Topic',
        DetailView: '题目详情',
        ListView: '',
        Page: '试卷详情题目列表',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Parent',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            NoConditionColumns: ['员工', '企业']
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    }],
    Exam: [{
        Title: '考试',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Exam',
        DetailView: '',
        ListView: '',
        Page: '考试',
        PageColumns: '',
        ViewType: '面板',
        Theme: '',
        Panel: 'Home4',
        PanelModule: '管理首页4',
        Role: '管理员自己',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Theme: 'top2'
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Parent'
        }],
        Id: 0
    },
    {
        Title: '考试管理',
        Code: '',
        ShowTitle: '',
        SortNo: 1,
        Path: 'Exam',
        DetailView: '',
        ListView: '',
        Page: '考试菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    },
    {
        Title: '考试管理',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Exam',
        DetailView: '考试详情',
        ListView: '',
        Page: '考试考试管理',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            LoadParams: {
                GetTicketList: true
            },
            NoConditionColumns: ['员工', '企业']
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 2
    },
    {
        Title: '考试详情',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Exam',
        DetailView: '',
        ListView: '',
        Page: '考试详情',
        PageColumns: '',
        ViewType: '视图面板',
        Theme: '',
        Panel: 'Detail',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 3
    }],
    Exam_Ticket: [{
        Title: '考试次数',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Exam.Ticket',
        DetailView: '',
        ListView: '',
        Page: '学员详情',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'DataPanel',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '考试记录',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Exam.Ticket',
        DetailView: '',
        ListView: '',
        Page: '学员详情',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'UsersListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Users',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            LoadParams: {
                GetFaceList: true,
                GetTopicList: true,
                TopicListSearchParams: {
                    GetPaperQuestion: true
                },
                ParentSearchParams: {
                    GetSignList: true,
                    GetPaper: true,
                    PaperSearchParams: {
                        GetTopicList: true
                    }
                },
                UsersSearchParams: {
                    GetCategory: true,
                    GetCompany: true
                },
                TrainingSearchParams: {
                    GetVideosList: true,
                    VideosListSearchParams: {
                        GetRecordList: true,
                        RecordListSearchParams: {
                            GetParent: true
                        }
                    }
                }
            }
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    },
    {
        Title: '学员培训明细',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Exam.Ticket',
        DetailView: '',
        ListView: '',
        Page: '学员培训明细',
        PageColumns: '',
        ViewType: '视图面板',
        Theme: '',
        Panel: 'Doc',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Users',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            LoadParams: {
                UsersSearchParams: {
                    GetCategory: true,
                    GetCompany: true
                }
            }
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 2
    },
    {
        Title: '企业学员培训记录',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Exam.Ticket',
        DetailView: '',
        ListView: '',
        Page: '企业学员培训记录',
        PageColumns: '',
        ViewType: '视图面板',
        Theme: '',
        Panel: 'Doc2',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Training',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            LoadParams: {
                GetTraining: true,
                TrainingSearchParams: {
                    GetLessonsList: true
                }
            }
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 3
    },
    {
        Title: '考生明细',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Exam.Ticket',
        DetailView: '',
        ListView: '',
        Page: '考试详情考生列表',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Parent',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            NoConditionColumns: ['员工', '企业']
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 4
    }],
    Lesson: [{
        Title: '课件数',
        Code: '',
        ShowTitle: '',
        SortNo: 1,
        Path: 'Lesson',
        DetailView: '',
        ListView: '',
        Page: '工作台第一排',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'DataPanel',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '课件',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Lesson',
        DetailView: '',
        ListView: '',
        Page: '课件',
        PageColumns: '',
        ViewType: '面板',
        Theme: '',
        Panel: 'Home4',
        PanelModule: '管理首页4',
        Role: '管理员自己',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Theme: 'top2'
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Parent'
        }],
        Id: 1
    },
    {
        Title: '课件管理',
        Code: '',
        ShowTitle: '',
        SortNo: 1,
        Path: 'Lesson',
        DetailView: '',
        ListView: '',
        Page: '课件菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 2
    },
    {
        Title: '课件管理',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Lesson',
        DetailView: '课件详情',
        ListView: '',
        Page: '课件课件管理',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ImagePanel',
        PanelModule: '标准图片列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            LoadParams: {
                GetChapterList: true,
                ChapterListSearchParams: {
                    GetItemsList: true
                }
            }
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 3
    },
    {
        Title: '课件详情',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Lesson',
        DetailView: '',
        ListView: '',
        Page: '课件详情',
        PageColumns: '',
        ViewType: '视图面板',
        Theme: '',
        Panel: 'Detail',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 4
    }],
    Lesson_Category: [{
        Title: '课件分类',
        Code: '',
        ShowTitle: '',
        SortNo: 2,
        Path: 'Lesson.Category',
        DetailView: '',
        ListView: '',
        Page: '课件菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '课件分类',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Lesson.Category',
        DetailView: '',
        ListView: '',
        Page: '课件课件分类',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            }
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    }],
    Lesson_Banners: [{
        Title: '轮播图',
        Code: '',
        ShowTitle: '',
        SortNo: 3,
        Path: 'Lesson.Banners',
        DetailView: '',
        ListView: '',
        Page: '课件菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '轮播图',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Lesson.Banners',
        DetailView: '',
        ListView: '',
        Page: '课件轮播图',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ImagePanel',
        PanelModule: '标准图片列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            }
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    }],
    Lesson_Chapter: [{
        Title: '章节明细',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Lesson.Chapter',
        DetailView: '',
        ListView: '',
        Page: '课件详情',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Parent',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            LoadParams: {
                GetItemsList: true
            }
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '章节明细',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Lesson.Chapter',
        DetailView: '',
        ListView: '',
        Page: '章节明细',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Parent',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            HideTitle: true,
            DisabledCondition: true,
            LoadParams: {
                GetItemsList: true
            }
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    }],
    Lesson_Chapter_Items: [{
        Title: '视频总数',
        Code: '',
        ShowTitle: '',
        SortNo: 2,
        Path: 'Lesson.Chapter.Items',
        DetailView: '',
        ListView: '',
        Page: '工作台第一排',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'DataPanel',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '课程子章节明细',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Lesson.Chapter.Items',
        DetailView: '',
        ListView: '',
        Page: '课程子章节明细',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            HideTitle: true,
            DisabledCondition: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    }],
    News: [{
        Title: '一周事故',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'News',
        DetailView: '',
        ListView: '',
        Page: '一周事故',
        PageColumns: '',
        ViewType: '面板',
        Theme: '',
        Panel: 'Home4',
        PanelModule: '管理首页4',
        Role: '管理员自己',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Theme: 'top2'
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Parent'
        }],
        Id: 0
    },
    {
        Title: '一周危化品物流安全事故分析',
        Code: '',
        ShowTitle: '',
        SortNo: 1,
        Path: 'News',
        DetailView: '',
        ListView: '',
        Page: '一周事故菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    },
    {
        Title: '一周危化品物流安全事故分析',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'News',
        DetailView: '',
        ListView: '',
        Page: '一周事故一周危化品物流安全事故分析',
        PageColumns: '',
        ViewType: '表单',
        Theme: '配置表单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            NoConditionColumns: ['员工', '企业']
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 2
    },
    {
        Title: '最新资讯详情',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'News',
        DetailView: '',
        ListView: '',
        Page: '最新资讯详情',
        PageColumns: '',
        ViewType: '视图面板',
        Theme: '',
        Panel: 'Detail',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 3
    }],
    SafeInfo: [{
        Title: '安全',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'SafeInfo',
        DetailView: '',
        ListView: '',
        Page: '安全',
        PageColumns: '',
        ViewType: '面板',
        Theme: '',
        Panel: 'Home4',
        PanelModule: '管理首页4',
        Role: '管理员自己',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Theme: 'top2'
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Parent'
        }],
        Id: 0
    },
    {
        Title: '三交代管理',
        Code: '',
        ShowTitle: '',
        SortNo: 1,
        Path: 'SafeInfo',
        DetailView: '',
        ListView: '',
        Page: '安全菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    },
    {
        Title: '三交代管理',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'SafeInfo',
        DetailView: '三交代详情',
        ListView: '',
        Page: '安全三交代管理',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            }
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 2
    },
    {
        Title: '三交代详情',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'SafeInfo',
        DetailView: '',
        ListView: '',
        Page: '三交代详情',
        PageColumns: '',
        ViewType: '视图面板',
        Theme: '',
        Panel: 'Detail',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 3
    }],
    SafeInfo_LearnRecord: [{
        Title: '三交代签到数',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'SafeInfo.LearnRecord',
        DetailView: '',
        ListView: '',
        Page: '学员详情',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'DataPanel',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    }],
    Mistake: [{
        Title: '曝光台',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Mistake',
        DetailView: '',
        ListView: '',
        Page: '曝光台',
        PageColumns: '',
        ViewType: '面板',
        Theme: '',
        Panel: 'Home4',
        PanelModule: '管理首页4',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Theme: 'top2'
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '曝光台管理',
        Code: '',
        ShowTitle: '',
        SortNo: 1,
        Path: 'Mistake',
        DetailView: '',
        ListView: '',
        Page: '曝光台菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    },
    {
        Title: '曝光台管理',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Mistake',
        DetailView: '曝光台详情',
        ListView: '',
        Page: '曝光台曝光台管理',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            }
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 2
    },
    {
        Title: '曝光台详情',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Mistake',
        DetailView: '',
        ListView: '',
        Page: '曝光台详情',
        PageColumns: '',
        ViewType: '视图面板',
        Theme: '',
        Panel: 'Detail',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 3
    }],
    Store: [{
        Title: '分公司数',
        Code: '',
        ShowTitle: '',
        SortNo: 3,
        Path: 'Store',
        DetailView: '',
        ListView: '',
        Page: '工作台第一排',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'DataPanel',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 0
    },
    {
        Title: '分公司数量',
        Code: '',
        ShowTitle: '',
        SortNo: 2,
        Path: 'Store',
        DetailView: '',
        ListView: '',
        Page: '企业详情',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'IndexPanel',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Company',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 1
    },
    {
        Title: '分公司管理',
        Code: '',
        ShowTitle: '',
        SortNo: 2,
        Path: 'Store',
        DetailView: '',
        ListView: '',
        Page: '企业菜单',
        PageColumns: '',
        ViewType: '按钮',
        Theme: '单行菜单',
        Panel: '',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            IsH: true
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 2
    },
    {
        Title: '分公司管理',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Store',
        DetailView: '分公司详情',
        ListView: '',
        Page: '企业分公司管理',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: '',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Export: {
                Title: '导出'
            },
            LoadParams: {
                GetProjectList: true
            },
            NoConditionColumns: ['员工', '企业']
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 3
    },
    {
        Title: '分公司',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Store',
        DetailView: '',
        ListView: '',
        Page: '企业详情',
        PageColumns: '',
        ViewType: '数据列表',
        Theme: '数据分页列表',
        Panel: 'ListPanel',
        PanelModule: '自定义列表面板',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Company',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {
            Add: {
                Title: '新增'
            },
            Import: {
                Title: '导入'
            },
            Export: {
                Title: '导出'
            },
            NoConditionColumns: ['员工', '企业']
        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 4
    },
    {
        Title: '企业管理分公司数',
        Code: '',
        ShowTitle: '',
        SortNo: '',
        Path: 'Store',
        DetailView: '',
        ListView: '',
        Page: '企业管理分公司数',
        PageColumns: '',
        ViewType: '数量统计',
        Theme: '',
        Panel: 'ListData',
        PanelModule: '',
        Role: '管理员作业人',
        Count: '',
        ParentField: 'Company',
        DateField: '',
        GroupFields: '',
        Fields: '',
        Config: {

        },
        ColumnConfig: '',
        DataField: '',
        SearchFields: '',
        SortFields: '',
        ViewParams: null,
        FrameModule: '',
        Scene: '',
        Propertys: '',
        Roles: [{
            Role: 'Manager',
            RoleField: 'Manager'
        }],
        Id: 5
    }]
}